import { EChartsOption } from 'echarts';
import {
  CHART_DEFAULTS,
  getAxisLabelConfig,
  getGridConfig,
  getLegendConfig,
  getSplitLineConfig,
  getTitleConfig,
} from '../constants/chart-theme.constants';
import { LineChartConfig, TimeSeriesChartConfig } from '../models/chart-types';

/**
 * Build ECharts options for line chart
 */
export function buildLineChartOptions(config: LineChartConfig | TimeSeriesChartConfig): EChartsOption {
  const theme = config.theme ?? 'dark';
  const options: EChartsOption = {
    title: getTitleConfig(config.title, config.subtitle, theme),

    tooltip: {
      trigger: config.tooltip?.trigger || 'axis',
      ...config.tooltip,
    },

    legend: getLegendConfig(config.legend, theme),

    grid: config.grid || getGridConfig(!!config.title),

    xAxis: {
      type: config.xAxis.type || 'category',
      boundaryGap: config.xAxis.boundaryGap !== undefined ? config.xAxis.boundaryGap : false,
      data: config.xAxis.data,
      name: config.xAxis.name,
      axisLabel: getAxisLabelConfig(config.xAxis.axisLabel, theme),
      axisLine: config.xAxis.axisLine,
      axisTick: config.xAxis.axisTick,
      splitLine: getSplitLineConfig(config.xAxis.splitLine, theme),
      ...config.xAxis,
    } as any,

    yAxis: {
      type: config.yAxis.type || 'value',
      name: config.yAxis.name,
      nameRotate: config.yAxis['nameRotate'],
      nameLocation: config.yAxis['nameLocation'],
      nameTextStyle: config.yAxis['nameTextStyle'],
      axisLabel: getAxisLabelConfig(config.yAxis.axisLabel, theme),
      axisLine: config.yAxis.axisLine,
      axisTick: config.yAxis.axisTick,
      splitLine: getSplitLineConfig(config.yAxis.splitLine, theme),
      ...config.yAxis,
    } as any,

    series: config.series.map((series) => ({
      name: series.name,
      type: 'line',
      data: series.data,
      smooth: series.smooth || false,
      showSymbol: series.showSymbol !== false,
      symbolSize: series.symbolSize ?? 6,
      color: series.color,
      lineStyle: series.lineStyle,
      areaStyle: series.areaStyle,
      emphasis: series.emphasis || {
        focus: CHART_DEFAULTS.emphasis.focus,
      },
    })),
  };

  // Merge with custom options if provided
  return config.customOptions 
    ? { ...options, ...config.customOptions }
    : options;
}

